import { Dispatch, FC, ReactNode, SetStateAction, useEffect, useRef, useState } from "react";
import { useClickOutOfElement } from "../custom-hooks/base-hooks/useClickOutOfElement";
import useBodyOverflowHidden from "../custom-hooks/base-hooks/useBodyOverflowHidden";
import useScreenSize from "../custom-hooks/base-hooks/useScreenSize";

interface CustomBurgerMenuProps {
    children: ReactNode;
    buttonElement: ReactNode;
    setBackgroundBlur: Dispatch<SetStateAction<boolean>>;
    backgroundBlur: boolean;
    popupClassName?: string;
    forceCloseMenu?: boolean;
    setForceCloseMenu?: (value: boolean) => void;
}

const CustomBurgerMenu: FC<CustomBurgerMenuProps> = (props) => {
    const [burgerMenuOpened, setBurgerMenuOpened] = useState(false);
    const { hidden, visible } = useBodyOverflowHidden();
    const { upTo800 } = useScreenSize();
    const burgerMenuRef = useRef(null);
    const openBurgerMenuHandler = () => {
        setBurgerMenuOpened(!burgerMenuOpened);
        props.setBackgroundBlur(!props.backgroundBlur);
        props.setForceCloseMenu && props.setForceCloseMenu(false);
        if (upTo800) {
            if (burgerMenuOpened) {
                visible();
            } else {
                hidden();
            }
        }
    };
    useClickOutOfElement(burgerMenuRef, () => {
        if (!burgerMenuOpened) {
            return;
        }
        setBurgerMenuOpened(false);
        props.setBackgroundBlur(false);
        if (upTo800 && burgerMenuOpened) visible();
    });
    useEffect(() => {
        if (props.forceCloseMenu) {
            setBurgerMenuOpened(false);
            props.setBackgroundBlur(false);
            return;
        }

        if (upTo800 && burgerMenuOpened) {
            window.scrollTo(0, 0);
            hidden();
        } else {
            visible();
        }
    }, [upTo800, burgerMenuOpened, props.forceCloseMenu]);

    return (
        <div ref={burgerMenuRef} className="relative">
            <div onClick={openBurgerMenuHandler}>{props.buttonElement}</div>
            <div className={burgerMenuOpened ? props.popupClassName : "hidden"}>{props.children}</div>
        </div>
    );
};

export default CustomBurgerMenu;
